import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import ListResourceV2 from './ListResourceV2.jsx';

import { env } from '../../config';

const ListArticles = () => {
  const [assigned, setAssigned] = useState('');
  const filter = assigned ? { assigned } : {};
  const { t, i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';

  return (
    <ListResourceV2
      {...{
        searchable: [
          { value: 'title', label: 'Title' },
          { value: 'refCode', label: 'Code' },
          {
            value: 'subjects',
            label: 'Subjects',
            options: Object.keys(env.subjects).map((g) => ({
              value: g,
              label: env.subjects[g][lang],
            })),
          },
          { value: 'tags', label: 'Tags' },
          { value: 'type', label: 'type', options: [{ value: 'text', label: t('text') }, { value: 'video', label: t('video') }] },
        ],
        actions: {
          saveAs: true,
          remove: ({ selected }) => {
            const condition = selected.find((v) => v.assignments.length);
            return {
              children: condition
                ? `${t('DeleteArticle1')} ${t('Are you sure?')}`
                : t('Are you sure you want to delete?'),
              theme: condition ? 'danger' : undefined,
            };
          },
        },
        api: '/api/quiz/articles',
        sort: { refCode: 1 },
        filter,
        cols: [
          {
            key: 'type',
            children: t('type'),
            getter: (v) => t(v),
          },
          { key: 'refCode', children: 'Code', sortable: true },
          { key: 'title', sortable: true },
          {
            key: 'subjects',
            getter: (v) => (v
              ? v.map((s) => (env.subjects[s] ? env.subjects[s][lang] : ''))
                .join(', ')
              : ''),
          },
          { key: 'tags', getter: (v) => (v || []).join(', ') },
          {
            key: 'latestAssignedDate',
            children: 'Assigned At',
            sortable: true,
            getter: (v, r) => r.assignments.map((a) => (
              <div key={a.date}>
                {moment(a.date).format('YYYY/MM/DD')}
              </div>
            )),
          },
        ],
        ctrls: [
          <select
            className="custom-select"
            key={0}
            value={assigned}
            onChange={(e) => setAssigned(e.target.value)}
          >
            <option value="">{t('Show All')}</option>
            <option value="1">{t('Assigned')}</option>
            <option value="0">{t('Unassigned')}</option>
          </select>,
        ],
      }}
    />
  );
};

export default ListArticles;
